import styled from 'styled-components';
import { vw } from 'components/common/Common';

export const JetMain = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f4f6fc;
`;

export const P = styled.p`
  font-size: ${vw(20)};
  font-weight: 400;
  line-height: 1.5;
  color: ${(props) => props.$color || '#050a30'};
  width: 100%;
  margin: ${vw(10)} 0;
  text-align: ${(props) => props.$align || 'left'};
`;

export const SvgIcon = styled.img`
  width: ${(props) => vw(props.$size)};
  height: ${(props) => vw(props.$size)};
  opacity: 0.8;
`;

export const H1 = styled.h1`
  font-size: ${vw(48)};
  font-weight: 700;
  line-height: 1.5;
  color: #fff;
  margin: 0 0;
`;

export const H2 = styled.h2`
  font-size: ${vw(48)};
  color: #050a30;
  font-weight: 700;
  width: 100%;
  text-align: ${(props) => props.$align || 'center'};
  margin: 0 auto;
`;

export const H3 = styled.h3`
  font-size: ${vw(32)};
  color: #050a30;
  font-weight: 600;
  width: 100%;
  margin: 0 0;
`;

export const Li = styled.li`
  font-size: ${vw(16)};
  color: #050a30;
  font-weight: 500;
  width: 100%;
  list-style-type: none;
`;

export const Link = styled.a`
  display: block;
  border: 2px solid ${(props) => props.$borderColor || '#0b8ae8'};
  padding: ${vw(6)} ${vw(24)};
  border-radius: ${vw(16)};
  font-weight: ${(props) => props.$weight || 500};
  line-height: 1.5;
  color: ${(props) => props.$color || '#0b8ae8'};
  text-decoration: none;
  font-size: ${vw(20)};
  width: fit-content;
  :hover {
    border-color: #40a9ff;
  }
`;

export const Span = styled.span`
  display: block;
  font-size: ${vw(20)};
  font-weight: ${(props) => props.$weight};
  line-height: 1.5;
  color: #050a30;
`;
